import { httpPost } from 'core/utils/httpClient';
import { SummaryRequest } from '../models/api';

export const getSummary = (data: SummaryRequest, mode: 'abs' | 'ext') =>
  httpPost(`/summarizer/summarize-para/${mode}`, data);
